import { useQuery } from "@tanstack/react-query";
import { Layer, Source } from "react-map-gl";
import {
  current_vectoring_opacity,
  proposed_vectoring_opacity,
} from "../../../colors";
import getData from "../../../requests/getData";

function ChangeVectoringLayer({
  layerId,
  beforeId,
  vectoringUrl,
  changeType,
  selectedNonWsiSwathes,
  persistent,
}) {
  const currentType = changeType === "current";
  const proposedType = changeType === "proposed";

  // Get the selected track ids
  const selectedTrackIds = selectedNonWsiSwathes.map((f) => f["track_id"]);

  if (!(currentType || proposedType)) {
    console.error(
      changeType +
        " (changeType) is not valid. It should be 'current' or 'proposed'."
    );
  }

  // Get the patterns
  const arrival_vectoring_pattern = currentType
    ? "shadingCurrent"
    : "shadingArrivals";
  const departure_vectoring_pattern = currentType
    ? "shadingCurrent"
    : "shadingDepartures";

  // Get the opacities
  const vectoring_opacities = currentType
    ? current_vectoring_opacity
    : proposed_vectoring_opacity;
  const default_vectoring_opacity =
    selectedNonWsiSwathes.length > 0
      ? vectoring_opacities[2]
      : persistent
      ? vectoring_opacities[3]
      : vectoring_opacities[0];

  const { isError, data, error } = useQuery({
    queryKey: ["changeVectoring", vectoringUrl],
    queryFn: async () => {
      const data = await getData(vectoringUrl);
      return data;
    },
    cacheTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    placeholderData: {
      type: "FeatureCollection",
      features: [],
    },
    onError: (error) => {
      console.error(error);
    },
  });

  if (isError) {
    console.error(error);
    return <></>;
  }

  // Set the source id
  const sourceId = layerId + "-data";

  return (
    <Source id={sourceId} type="geojson" data={data}>
      <Layer
        source={sourceId}
        id={layerId}
        beforeId={beforeId}
        type="fill"
        paint={{
          "fill-pattern": [
            "case",
            ["==", ["get", "movement_type"], ["literal", "Arrival"]],
            arrival_vectoring_pattern,
            departure_vectoring_pattern,
          ],
          "fill-opacity": [
            "case",
            [
              "boolean",
              ["in", ["get", "track_id"], ["literal", selectedTrackIds]],
              false,
            ],
            vectoring_opacities[1],
            default_vectoring_opacity,
          ],
        }}
      />
    </Source>
  );
}

export default ChangeVectoringLayer;
